import React from 'react';
import {
  Col, Flex, Image, Row,
} from 'antd';
import styled from 'styled-components';
import { ButtonMainRed } from './button/ButtonMainRed';
import { DivMinWidth } from '../App';
import { paths } from '../consts';
import { useResizeWidthWindow } from './hook/useResizeWidthWindow';
import { fonts } from '../assets/constStyles';

const BackgroundContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: black;
  padding: 100px 0;

  @media (max-width: 768px) {
    padding: 50px 0;
  }
`;

const FlexIconStyled = styled(Flex)`
  padding: 40px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const IconStyled = styled(Image)`
  width: 300px !important;
  height: 70px;
  object-fit: cover;

  @media (max-width: 768px) {

  }
`;

const FlexButtonAwards = styled(Flex)`
  @media (max-width: 768px) {
    text-align: center;
  }
  `;

const FlexPreviousAwardStyled = styled(Flex)`
    margin-top: 50px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 20px;
  }
  `;

const FlexAwardStyled = styled(Flex)`
  @media (max-width: 768px) {
    padding: 10px;
    text-align: center;
  }
`;

const PAwardsBack = styled.p`
  font-size: 20px;
  font-family: ${fonts.font2};
    `;

const PCaptionStyled = styled.p`
  color: white;
  font-size: 1.8em;
  font-weight: bold;
  text-transform: uppercase;
  font-family: ${fonts.font2};

  @media (max-width: 768px) {
    font-size: 1.4em;
  }
`;

const PSubCaptionStyled = styled.p`
  color: white;
  font-size: 1.5em;
  font-family: "futura-pt", sans-serif;

  @media (max-width: 768px) {
    font-size: 1.2em;
  }
`;

export const BlockAwards: React.FC = () => (
    <div style={{ position: 'relative' }}>
        <BackgroundContainer>
            <DivMinWidth>
                <Row align="stretch">
                    <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                        <FlexIconStyled vertical align={'center'} justify={'space-between'}
                                        style={{ padding: '0px 12px', height: '100%' }}>
                            <IconStyled src={'../img/awardsAnnual.png'} preview={false}></IconStyled>
                        </FlexIconStyled>
                    </Col>
                    <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                        <FlexAwardStyled vertical gap={40}>
                            <PCaptionStyled>Welcome to the 35<sup><span style={{ textTransform: 'lowercase' }}>th</span></sup> AWMAC BC Awards of Excellence.</PCaptionStyled>
                            <PSubCaptionStyled>
                                Join us for the stunning architectural woodwork projects celebrated at
                                the 35th AWMAC BC Awards of Excellence. We are proud to acknowledge the category winners
                                and recognize the achievements of those entering our industry.
                            </PSubCaptionStyled>
                            <FlexButtonAwards justify={useResizeWidthWindow() < 700 ? 'center' : 'flex-start'}>
                                <ButtonMainRed text={'Learn More'} route={paths.AWARDS}/>
                            </FlexButtonAwards>
                        </FlexAwardStyled>
                    </Col>
                </Row>
            </DivMinWidth>
        </BackgroundContainer>
        <DivMinWidth>
            <FlexPreviousAwardStyled justify={'center'} vertical>
                <PAwardsBack>A view back on our last Awards of Excellence, including projects
                    submitted.</PAwardsBack>
                <PAwardsBack>Award winners, moments of the Gala nights, and much more.</PAwardsBack>
                <Flex style={{ marginTop: 30 }} justify={'center'}>
                    <ButtonMainRed text={'Learn More'} route={paths.AWARDS}/>
                </Flex>
            </FlexPreviousAwardStyled>
        </DivMinWidth>
    </div>
);
